<div class="container" style="height: 80vh">
    <div>
        <h1 class="inv_head"> Investor Information</h1>
        <p class="inv_contact"> We will be happy to share our story in detail with you. Reach out to us on <span class="comp_owner"> prabhat.tiwary@yourownroom.com </span> or <span class="comp_owner"> sachin.joshi@yourownroom.com </span> </p>
    </div>
    <hr>
    <div class="row">
        <div class="col-md-4" style="padding-top: 40px; font-size: 16px;">
            <ul>
                <li style="font-family: Montserrat; cursor: pointer; color: #23547f;">
                    <a class="investor_year" (click)="selectedYear('2020-21')" [ngClass]="investorDetails.year === '2020-21' ? 'selectedFinYear' : 'finYear'"> 2020-21 Financial Result </a>
                </li>
                <li style="font-family: Montserrat; cursor: pointer; color: #23547f; margin-top: 20px">
                    <a class="investor_year" (click)="selectedYear('2021-22')" [ngClass]="investorDetails.year === '2021-22' ? 'selectedFinYear' : 'finYear'"> 2021-22 Financial Result </a>
                </li>
            </ul>
        </div>
        <div class="col-md-6">
            <div>
                <form role="form">
                    <div class="inv_fields">
                        <p> Name </p>
                        <input type="text" name="name" class="investor_form form-control" id="name" [ngModel]="investorDetails.name" (ngModelChange)="onNameChange($event)"  placeholder="Please enter your name"> 
                    </div>
                    <div class="inv_fields">
                        <p>Phone Number </p>
                        <input type="tel" name="phone" class="investor_form form-control" id="phone" [ngModel]="investorDetails.phone" (ngModelChange)="onPhoneChange($event)" placeholder="Please enter your phone number" pattern="[0-9]{10}">
                    </div>
                    <div class="inv_fields">
                        <p>Email </p>
                        <input name="email" type="email" class="investor_form form-control" id="email" [ngModel]="investorDetails.email" (ngModelChange)="onEmailChange($event)" placeholder="Please enter your email id"> 
                    </div>
                    <div class="col-12 " style="margin-top: 40px; padding: 0">
                        <button type="button" class="inv_submit" (click)="submitInvestorForm()" >Submit </button>
                    </div>

                    <div class="form_sub_msg_pass" *ngIf="submit_form == true">
                        <p> {{ show_msg }} </p>
                    </div>
                    <div class="form_sub_msg" *ngIf="submit_form == false">
                        <p> {{ show_msg }} </p>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>

